
import { defineComponent, ref, PropType } from "vue";
import { Slider } from "vant";
import { AudioDetail } from "../hooks/useAudioPlay";

export default defineComponent({
  components: {
    [Slider.name]: Slider,
  },

  props: {
    modelValue: {
      type: Number,
      default: 0,
    },
    audioDuration: {
      type: String,
      default: "00 : 00",
    },
    audioCurrentTime: {
      type: String,
      default: "00 : 00",
    },
    isPaused: {
      type: Boolean,
      default: true,
    },
    audioDetail: {
      type: Object as PropType<AudioDetail>,
      required: true,
    },
  },

  emits: ["update:modelValue", "changePlayStatus", "onChangeCurrentTime"],

  setup(props, context) {
    const audioChildCurrentSlider = ref(0);

    const sliderChange = (value: number) => {
      context.emit("onChangeCurrentTime", value);
    };

    const changePlayStatus = () => {
      context.emit("changePlayStatus", props.isPaused);
    };

    // 改变进度条的进度
    const changeAudioChildCurrentSlider = (e: number) => {
      audioChildCurrentSlider.value = e;
      context.emit("update:modelValue", e);
    };

    return {
      audioChildCurrentSlider,
      sliderChange,
      changePlayStatus,
      changeAudioChildCurrentSlider,
    };
  },
});
